module.exports = __webpack_public_path__ + "img/Twitter.eb920ed6.svg";